






























































import Vue, { PropType } from 'vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { Seller } from '~/models/classified/types'
import { faPaperPlane, faPhone } from '@fortawesome/free-solid-svg-icons'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import StatsService from '~/services/stats/StatsService'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { SET_FLOATING_BUTTONS_MESSAGE_PHONE_VISIBILITY } from '~/store/modules/shared/classifieds/view/mutation-types'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ScrollService from '~/services/scroll/ScrollService'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'

export default Vue.extend({
  components: {
    CClassifiedFavoriteButton,
    PhoneListPopup: () =>
      import(
        '~/components/car/classifieds/view/partials/call-button/PhoneListPopup'
      ),
    CContactFormModal: () =>
      import(
        '~/components/shared/configurable/contact-form-modal/CContactFormModal.vue'
      )
  },
  props: {
    forceVisible: { type: Boolean, default: false },
    seller: {
      type: Object as PropType<Seller>,
      required: true
    },
    offset: {
      type: Number,
      required: false,
      default: 90
    },
    messageButtonText: {
      type: String,
      default() {
        return this.$t('message')
      }
    },
    contactRef: { type: null, required: true },
    classifiedId: { type: Number, required: true },
    showMessageButton: { type: Boolean, default: false },
    showParking: { type: Boolean, default: false }
  },
  data() {
    return {
      openTelPopup: false,
      isContactFormModalVisible: false,
      icons: {
        phone: faPhone,
        email: faPaperPlane
      }
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => state.classified,
      isButtonsVisible: state => state.isFloatingButtonsMessagePhoneVisible,
      showContact: state => state.showContact,
      showContactPrompt: state => state.showContactPrompt,
      currentUser: state => state.currentUser
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, ['sellerOnlyContactViaMessages']),
    ...mapDeps({
      scrollService: ScrollService
    }),
    htmlElement(): HTMLElement {
      return this.contactRef instanceof HTMLElement
        ? this.contactRef
        : this.contactRef?.$el
    },
    sellerHasPhone() {
      return (
        this.seller.telephone1 ||
        this.seller.telephone2 ||
        this.seller.mobile ||
        this.seller.extra_telephone
      )
    }
  },
  mounted() {
    if (this.isMobile) {
      window.addEventListener('scroll', this.handleScroll, false)
    }
  },
  destroyed() {
    if (this.isMobile) {
      window.removeEventListener('scroll', this.handleScroll)
    }
    this.handleCloseTelPopup()
  },

  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setVisibility: SET_FLOATING_BUTTONS_MESSAGE_PHONE_VISIBILITY
    }),
    handleScroll() {
      let isVisible = false
      if (this.htmlElement && !this.forceVisible) {
        const { top } = this.htmlElement.getBoundingClientRect()

        if (top + 58 <= window.innerHeight) {
          isVisible = false
        } else if (!isVisible) {
          isVisible = true
        }
      } else if (window.scrollY > 52) {
        isVisible = true
      } else {
        isVisible = false
      }
      if (isVisible !== this.isButtonsVisible) {
        this.setVisibility(isVisible)
      }
    },
    handleCallServiceButtonClick(url: string) {
      window.location.href = url
      const scheme = url.substring(0, url.indexOf(':'))
      const statSuffix = scheme === 'tel' ? '' : '.' + scheme
      const statsService = this.$dep(StatsService)
      statsService.record('events.clsfds.telephone_click' + statSuffix, [
        this.classifiedId
      ])
    },
    scrollToContact() {
      if (this.htmlElement) {
        this.scrollService.scrollTo(this.htmlElement, {
          easing: 'ease-out',
          offset: -this.offset,
          duration: 500
        })
      }
    },
    handleCloseTelPopup() {
      this.openTelPopup = false
    },
    handleShowContactForm() {
      if (this.htmlElement) {
        this.scrollToContact()
      } else {
        this.isContactFormModalVisible = true
      }
    }
  }
})
